import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  connect() {
    this.formTarget.classList.add("hidden")
  }

  toggle() {
    this.formTarget.classList.toggle("hidden")
  }
}
